<template>
  <div class="coensmCmss">
    <div class="promote">
      <van-nav-bar
        :title="$t('components._Bnusdeprimeirodepsito')"
        left-arrow
        fixed
        placeholder
        :right-text="$t('promote._Histórico')"
        @click-right="openUrl('records')"
        @click-left="onClickLeft"
      />
      <div class="_event-lucky-wheel_1yc53_17">
        <div class="R57xbU1vEwuho81iaSVT-conter">
          <div class="van-row">
            <!-- -->
            <div
              style="
                width: 100%;
                border-radius: 0.1rem;
                margin-bottom: 0.2rem;
                background-color: var(--theme-main-bg-color);
                padding: 0.2rem;
                font-size: 0.28rem;
              "
            >
              <div
                class="flex items-center justify-between"
                style="width: 100%; margin-bottom: 0.2rem"
              >
                <div class="currencyAmount" style="text-align: left">
                  Tarefa de recarga para novos membros
                </div>
                <div class="currencyAmount flex items-center justify-center">
                  <div
                    class="flex items-center"
                    style="justify-content: end"
                    @click="getNotification"
                  >
                    <svg-icon
                      classNameQita
                      icon-class="icon-reload"
                      class="item-svg"
                      :class="{
                        animate__manimated: animate__manimated
                      }"
                      style="
                        color: #fff;
                        font-size: 0.2rem;
                        margin-left: 0.1rem;
                        vertical-align: text-bottom;
                        width: 0.28rem;
                        height: 0.28rem;
                      "
                    />
                  </div>
                  <span
                    style="
                      line-height: 1.2;
                      word-break: break-word;
                      margin-left: 0.1rem;
                    "
                    >Atualizar</span
                  >
                </div>
              </div>

              <div class="conterms" v-for="(item, index) in formDate.list">
                <img
                  src="../../assets/mine30/depositReward.webp"
                  alt=""
                  style="width: 0.9rem; height: 0.9rem"
                />
                <div
                  style="
                    color: var(--theme-text-color-lighten);
                    text-align: left;
                    margin-left: 0.1rem;
                    margin-right: 0.2rem;
                    flex-grow: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    height: 100%;
                  "
                >
                  <span
                    >{{ $t('Recharge._Firstdeposit') }} ≥ {{ item.recharge }},
                    {{ $t('_homeTile_tab._Bonus') }}
                    <span style="color: var(--theme-secondary-color-finance)">
                      {{ item.bonus }}
                    </span></span
                  >
                  <div class="nUtoDOFYqni_cq_dHUjg">
                    <div class="i9WaVhztJIXx90Q1PPLD">
                      <div class="J5dtKM_LB6fse7jhX2hk FPKXpabqN25lBr4IA7LQ">
                        <div
                          class="MtFB4D3SHXXdqKU0qelp SC6yMRCGE2upeyEdgibm"
                          :style="{
                            width: `${
                              (removeThousandSeparatorAndDecimalPoint(
                                formDate.now_recharge
                              ) /
                                removeThousandSeparatorAndDecimalPoint(
                                  item.recharge
                                )) *
                              100
                            }%`
                          }"
                        ></div>
                        <span class="kNDhRFHNQ398GxjnCVlg u5sLSrD0KWEulumHoUzc">
                          {{ formDate.now_recharge }}/
                          {{ item.recharge }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <van-button
                  @click="!formDate.close_recharge ? $store.commit('isDeposit', true) : ''"
                  :class="formDate.close_recharge ? 'ant-btn ant-btn-primary1 yJrr5gS3ZL4NGzZkaPXH' : 'ant-btn ant-btn-primary yJrr5gS3ZL4NGzZkaPXH'"
                  type="info"
                  native-type="submit"
                >
                  {{ $t('_VIP._Depósito') }}</van-button
                >
              </div>
            </div>
          </div>
        </div>

        <div class="public-introduction _introduction_109ll_17">
          <div class="introduction-inner">
            <div class="_introduction-item_1j44v_99">
              <div class="_introduction-title_cvq4f_52">
                <div class="_title-container_cvq4f_52">
                  <span class="_title-text_cvq4f_70"
                    >Hora do evento (UTC-3)</span
                  ><i class="_arrow_cvq4f_87"></i>
                </div>
              </div>
              <div>
                <span
                  ><span dir="ltr">04/07/2026 00:00:00</span><span> - </span
                  ><span dir="ltr">31/07/2036 23:59:59</span></span
                ><!---->
              </div>
            </div>
            <div class="_introduction-item_1j44v_99">
              <div class="_introduction-title_cvq4f_52">
                <div class="_title-container_cvq4f_52">
                  <span class="_title-text_cvq4f_70"
                    >Descrição da atividade</span
                  ><i class="_arrow_cvq4f_87"></i>
                </div>
                <div class="">
                  1.Durante o período da atividade, se o número de recargas e o
                  valor da recarga atenderem aos requisitos da atividade, você
                  poderá obter a recompensa correspondente. A recompensa máxima
                  é 5.000,00<br />2.Apenas recargas via Total de depósitos podem
                  receber recompensas. Após o sucesso da recarga, você pode
                  verificar nos detalhes da atividade ou na página de pendentes.
                  Se não vir a recompensa, tente clicar em atualizar ou aguarde
                  alguns minutos e tente novamente<br />3.As recompensas obtidas
                  Resgatar ao vivo，apenas podem ser resgatadas manualmente no
                  terminal PC,Android_H5,iOS_H5,Android_APP,iOS_APP<br />4.Após
                  o fim de cada ciclo, 1Dia a recompensa expira. Se não for
                  resgatada, será anulada diretamente<br />5.O bônus concedido
                  neste evento (bônus + principal) exige 6,00 vezes em apostas
                  válidas para ser sacado, com apostas em Não limitado a
                  plataformas de jogos
                </div>
              </div>
            </div>
            <div class="_introduction-item_1j44v_99">
              <div class="_introduction-title_cvq4f_52">
                <div class="_title-container_cvq4f_52">
                  <span class="_title-text_cvq4f_70">Termos e Condições</span
                  ><i class="_arrow_cvq4f_87"></i>
                </div>
                <div class="">
                  1. Cada jogador só pode usar uma conta. Contas múltiplas são
                  proibidas. Jogadores que abrirem contas múltiplas ou
                  fraudulentas serão desqualificados da atividade, e quaisquer
                  fundos restantes poderão ser confiscados e suas contas
                  congeladas.<br />2. Este site reserva-se o direito de
                  modificar, alterar, encerrar, cancelar ou recusar esta
                  atividade promocional a seu exclusivo critério.<br />3. Os
                  jogadores que participarem da atividade devem aceitar e
                  cumprir os termos desta atividade. A inscrição nesta oferta
                  significa a aceitação das regras da atividade e dos termos
                  correspondentes.<br />4. Para evitar ambiguidades, este site
                  reserva-se o direito de interpretação final desta atividade.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  -->
    <div class="orkXHvtNM5R_5twq6l5I">
      <button
        type="button"
        @click="onClickLeft"
        class="ant-btn RRWQlUJLCPB59ggBUdFl"
      >
        {{ $t('_buome._Retornar') }}
      </button>
      <!-- :disabled="!formDate.open_tips" -->
      <van-button
        @click="ReceberTudo"
        class="ant-btn ant-btn-primary yJrr5gS3ZL4NGzZkaPXH"
        v-if="formDate.open_tips"
        type="info"
        native-type="submit"
      >
        {{ $t('_home._ReceberTudo') }}</van-button
      >
      <van-button
        class="ant-btn ant-btn-primary1 yJrr5gS3ZL4NGzZkaPXH"
        v-else
        type="info"
        native-type="submit"
      >
        {{ $t('_home._ReceberTudo') }}</van-button
      >
    </div>
    <event></event>
  </div>
</template>

<script>
import {
  luckyTurntable,
  startTurntable,
  claimActivityRewards,
  lossSubsidy,
  firstRecharge
} from '@/apis/modules/detail.js';
import { Toast } from 'vant';
import event from '@/components/event.vue';
import { mapState } from 'vuex';
export default {
  components: {
    event
  },
  computed: {
    ...mapState(['popList', 'tabNav', 'banner', 'sidebarsList', 'marquee']),
    userInfo() {
      if (this.$store.state.userInfo && this.$store.state.userInfo.vip_info) {
        return this.$store.state.userInfo;
      } else {
        return { vip_info: {} };
      }
    }
  },
  data() {
    return {
      tabIntdex: 'none',
      type: 1,
      formDate: {},
      is_my: 0,
      animate__manimated: false
    };
  },
  created() {
    this.getNotification();
    // this.startTurntable();
  },
  methods: {
    startTurntable() {
      startTurntable({
        type: this.type
      }).then(({ code, data, msg }) => {
        //404
        let { marquee } = data;
      });
    },
    getNotification() {
      this.animate__manimated = true;
      firstRecharge({}).then(({ code, data, msg }) => {
        //404
        let { marquee } = data;
        this.formDate = data;
        let time = setTimeout(() => {
          clearTimeout(time);
          this.animate__manimated = false;
        }, 300);
      });
    },
    ReceberTudo() {
      claimActivityRewards({
        activity: 'firstRecharge'
      }).then(({ code, data, msg }) => {
        //404
        if (code == 0) {
          Toast.success(msg);
          this.getNotification();
        } else {
          Toast.loading(msg);
        }
      });
    },
    Detalhes() {},
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style>
/* --theme-alt-neutral-2 */
.coensmCmss .van-nav-bar__right,
.coensmCmss .van-nav-bar__text {
  color: var(--theme-primary-color) !important;
}

._event-lucky-wheel_1yc53_17 {
  padding: 0.2rem;
}
._introduction_109ll_17 .introduction-inner {
  padding: 0.2rem;
  overflow-y: auto;
  color: var(--theme-text-color);
  font-size: 0.26rem;
  line-height: 0.42rem;
  white-space: pre-wrap;
  word-break: break-word;
  background-color: var(--theme-main-bg-color);
  border-radius: 0.1rem;
  box-shadow: 0 0.03rem 0.09rem rgba(0, 0, 0, 0.06);
  overflow: visible;
}
._introduction_109ll_17 .introduction-inner .text-darken {
  font-weight: 700;
}

._event-lucky-wheel_1yc53_17 .lucky-wheel-item {
}

._event-lucky-wheel_1yc53_17 .turntable {
  padding: 0 0.2rem 0.2rem;
}

._event-lucky-wheel_1yc53_17 .lucky-wheel-tabs {
  flex: 1;
  background-color: var(--theme-main-bg-color);
  border-radius: 0.14rem;
  box-shadow: 0 0.03rem 0.09rem 0 var(--theme-bg-shadow);
}

._event-lucky-wheel_1yc53_17 .lucky-wheel-tabs .ui-tabs__wrap {
  height: 0.8rem;
  padding: 0 0.2rem;
  border-bottom: var(--lobby__px) solid var(--theme-color-line);
}

._event-lucky-wheel_1yc53_17 .lucky-wheel-tabs .ui-tabs__wrap .ui-tabs__nav {
  gap: 0.6rem;
  overflow-x: scroll;
  overflow-y: hidden;
  max-width: 100%;
}

._event-lucky-wheel_1yc53_17 .lucky-wheel-tabs .ui-tabs__wrap .ui-tab {
  flex: none;
  font-size: 0.26rem;
}

._event-lucky-wheel_1yc53_17 .lucky-wheel-tabs .ui-tabs__content {
  height: calc(100% - 0.8rem);
  padding: 0.2rem 0 0.2rem 0.2rem;
}

._event-lucky-wheel_1yc53_17 .public-introduction {
  padding: 0;
  margin-top: 0;
}

._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.05rem;
  background-color: var(--theme-main-bg-color);
  border-radius: 0.05rem;
  box-shadow: 0 0.02rem 0.04rem 0 var(--skin__web_left_bg_shadow);
}

._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20
  ._nav-item-inner_hp4jz_30 {
  position: relative;
  width: 100%;
  height: 0.8rem;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  opacity: 1;
}

._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20
  ._nav-item-inner_hp4jz_30
  ._active-icon_hp4jz_38 {
  display: block;
  width: 0.86rem;
  height: 0.78rem;
  background-size: 100% 100%;
}

._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20
  ._checked-status_hp4jz_44 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  border: thin solid var(--skin__primary);
  border-radius: 0.05rem;
  overflow: hidden;
}

._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20
  ._checked-status_hp4jz_44
  ._checked-status-subscript_hp4jz_55
  i[class~='bg'] {
  color: var(--skin__filter_active) !important;
}

._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20
  ._checked-status_hp4jz_44
  ._checked-status-subscript_hp4jz_55
  .bg {
  transform: rotate(45deg) scale(1.4);
  position: relative;
  left: 0.15rem;
  top: 0.15rem;
  background-color: var(--skin__filter_active);
}

._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20
  ._checked-status_hp4jz_44
  ._checked-status-subscript_hp4jz_55
  .gou {
  z-index: 1;
}

._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20:not(
    ._is-checked_hp4jz_68
  )
  ._checked-status_hp4jz_44 {
  display: none;
}

._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20._is-checked_hp4jz_68
  ._checked-status_hp4jz_44 {
  display: block;
}

._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20
  ._nav-item-inner_hp4jz_30
  ._active-icon_hp4jz_38 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
}

._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.05rem;
  background-color: var(--theme-main-bg-color);
  border-radius: 0.05rem;
  box-shadow: 0 0.02rem 0.04rem 0 var(--skin__web_left_bg_shadow);
}

._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20
  ._nav-item-inner_hp4jz_30 {
  position: relative;
  width: 100%;
  height: 0.8rem;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  opacity: 1;
}

._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20
  ._nav-item-inner_hp4jz_30
  ._active-icon_hp4jz_38 {
  display: block;
  width: 0.86rem;
  height: 0.78rem;
  background-size: 100% 100%;
}

._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20
  ._checked-status_hp4jz_44 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  border: thin solid var(--skin__primary);
  border-radius: 0.05rem;
  overflow: hidden;
}

._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20
  ._checked-status_hp4jz_44
  ._checked-status-subscript_hp4jz_55
  i[class~='bg'] {
  color: var(--skin__filter_active) !important;
}

._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20
  ._checked-status_hp4jz_44
  ._checked-status-subscript_hp4jz_55
  .bg {
  transform: rotate(45deg) scale(1.4);
  position: relative;
  left: 0.15rem;
  top: 0.15rem;
  background-color: var(--skin__filter_active);
}

._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20
  ._checked-status_hp4jz_44
  ._checked-status-subscript_hp4jz_55
  .gou {
  z-index: 1;
}

._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20:not(
    ._is-checked_hp4jz_68
  )
  ._checked-status_hp4jz_44 {
  display: none;
}

._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20._is-checked_hp4jz_68
  ._checked-status_hp4jz_44 {
  display: block;
}

._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20
  ._nav-item-inner_hp4jz_30
  ._active-icon_hp4jz_38 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
}

._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.05rem;
  background-color: var(--theme-main-bg-color);
  border-radius: 0.05rem;
  box-shadow: 0 0.02rem 0.04rem 0 var(--skin__web_left_bg_shadow);
}

._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20
  ._nav-item-inner_hp4jz_30 {
  position: relative;
  width: 100%;
  height: 0.8rem;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  opacity: 1;
}

._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20
  ._nav-item-inner_hp4jz_30
  ._active-icon_hp4jz_38 {
  display: block;
  width: 0.86rem;
  height: 0.78rem;
  background-size: 100% 100%;
}

._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20
  ._checked-status_hp4jz_44 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  border: thin solid var(--skin__primary);
  border-radius: 0.05rem;
  overflow: hidden;
}

._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20
  ._checked-status_hp4jz_44
  ._checked-status-subscript_hp4jz_55
  i[class~='bg'] {
  color: var(--skin__filter_active) !important;
}

._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20
  ._checked-status_hp4jz_44
  ._checked-status-subscript_hp4jz_55
  .bg {
  transform: rotate(45deg) scale(1.4);
  position: relative;
  left: 0.15rem;
  top: 0.15rem;
  background-color: var(--skin__filter_active);
}

._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20
  ._checked-status_hp4jz_44
  ._checked-status-subscript_hp4jz_55
  .gou {
  z-index: 1;
}

._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20:not(
    ._is-checked_hp4jz_68
  )
  ._checked-status_hp4jz_44 {
  display: none;
}

._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20._is-checked_hp4jz_68
  ._checked-status_hp4jz_44 {
  display: block;
}

._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20
  ._nav-item-inner_hp4jz_30
  ._active-icon_hp4jz_38 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: none;
}

._bottom-nav-item_1yyzn_17 ._active-name_1yyzn_17 {
  margin-top: 0.1rem;
  font-size: 0.18rem;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

._bottom-nav-item_1yyzn_17:not(._is-checked_1yyzn_26) ._active-name_1yyzn_17 {
  color: var(--theme-text-color);
}

._bottom-nav-item_1yyzn_17._is-checked_1yyzn_26 ._active-name_1yyzn_17 {
  color: var(--skin__primary);
}

._bottom-nav-item_1yyzn_17 {
  opacity: 1;
}

._activities-bar-item_ycxm1_17 {
  width: 1.88rem;
}

._events-bar_19vjj_17 {
  display: flex;
  align-items: center;
  padding-bottom: 0;
  justify-content: center;
  width: 100%;
  padding-right: 0.2rem;
  padding-left: 0.2rem;
}

._events-bar_19vjj_17 .ui-tabs {
  max-width: 100%;
}

._events-bar_19vjj_17 .ui-tabs .ui-tabs__wrap .ui-tabs__nav {
  background-color: transparent;
}

._events-bar_19vjj_17 .ui-tabs .ui-tabs__wrap {
  border-bottom: unset;
}

._events-bar_19vjj_17 .ui-tabs__line,
._events-bar_19vjj_17 .ui-tabs__content {
  display: none;
}

._events-bar_19vjj_17 .ui-tabs__nav--line {
  padding-bottom: 0;
}

._events-bar_19vjj_17 ._event-bar-item_19vjj_42 {
  padding: 0;
  margin-right: 0.2rem;
}

._events-bar_19vjj_17 > div {
  max-width: 100%;
}

._events-bar_19vjj_17 ._swiper-container_19vjj_49 {
  height: 0.9rem;
}

._events-bar_19vjj_17 ._scrollEvents_19vjj_52 {
  flex-shrink: 0;
  width: 0.4rem;
  height: 0.4rem;
  margin-bottom: 0.14rem;
  color: var(--skin__primary);
  font-size: 0.18rem;
  line-height: 0.4rem;
  text-align: center;
  background-color: var(--theme-main-bg-color);
  border: thin solid var(--theme-color-line);
  border-radius: 50%;
  cursor: pointer;
}

._events-bar_19vjj_17 ._scrollEvents_19vjj_52:first-child {
  margin-right: 0.1rem;
}

._events-bar_19vjj_17 ._scrollEvents_19vjj_52:last-child {
  margin-left: 0.1rem;
}

._events-bar_19vjj_17 ._scrollEvents_19vjj_52._btnDisabled_19vjj_72 {
  color: var(--theme-text-color);
  cursor: no-drop;
}

._visible-hidden_19vjj_77 {
  visibility: hidden;
}

._swiperSlideWidth_19vjj_81 {
  width: 1.88rem !important;
}

._nav2Wraper_19vjj_85 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

._nav2Wraper_19vjj_85 li:first-child {
  margin-right: 0.25rem;
}

._nav2Wraper_19vjj_85 .swiper-slide,
._nav4Wrapper_19vjj_100 .swiper-slide {
  width: 1.88rem !important;
  margin-right: 0.2rem !important;
  transform: translate(-0.3rem);
}

._navless4Wrapper_19vjj_106 .swiper-slide {
  width: 1.88rem !important;
}

._header-sub-btn_17wo2_17 {
  position: absolute;
  right: 0;
  width: 1.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0.1rem;
  text-align: center;
  color: var(--skin__primary);
  font-size: 0.24rem;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

._header-sub-btn_17wo2_17:lang(zh) {
  word-break: break-all;
}

._header-sub-btn_17wo2_17:not(:lang(zh)) {
  word-break: break-word;
}

._event-item-box_qhu5g_17 .lobby-scroll {
  z-index: initial;
}

._event-item-box_qhu5g_17 .ui-placeholder__nested-loading {
  max-height: calc(var(--lobby__screen-height) - 1.8rem);
}

._event-item-header_qhu5g_24 ._event-header-center_qhu5g_24 {
  max-width: 4.3rem;
  word-break: break-all;
  text-align: center;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

._event-item-header_qhu5g_24 ._event-header-center_qhu5g_24:not(:lang(zh)) {
  word-break: break-word;
}

._customizeWrap_qhu5g_39 {
  min-height: 100%;
  overflow-y: scroll;
  display: flex;
  flex-flow: column;
}

._placeholder-box_qhu5g_46 {
  min-height: 6rem;
}

._bar_qhu5g_50._normal_qhu5g_50 {
  margin-bottom: 0.2rem;
}

._bar_qhu5g_50._bottom-btn_qhu5g_53 {
  margin-bottom: 1.3rem;
}

._bar_qhu5g_50._customize-bottom-btn_qhu5g_56 {
  margin-bottom: 1.8rem;
}

._ranking-list-bottom-box_ov7eu_17 {
  display: flex;
  flex-direction: column;
  margin: 0.2rem;
  padding: 0.2rem;
  color: var(--theme-text-color);
  font-size: 0.22rem;
  background-color: var(--theme-main-bg-color);
  border-radius: 0.1rem;
  box-shadow: 0 0.03rem 0.09rem rgba(0, 0, 0, 0.06);
}

._ranking-list-bottom-box_ov7eu_17
  .ui-placeholder--nested
  .ui-placeholder__nested-loading {
  height: calc(0.5 * var(--lobby__screen-height) - 1.2rem);
}

._ranking-list-bottom-box_ov7eu_17 > h1 {
  color: var(--theme-text-color);
  font-size: 0.24rem;
  text-align: center;
  font-weight: 400;
  margin-bottom: 0.2rem;
}

._ranking-list-bottom-box_ov7eu_17 ._ranking-box_ov7eu_38 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

._ranking-list-bottom-box_ov7eu_17 ._ranking-info_ov7eu_44 {
  margin-right: 0.1rem;
}

._ranking-list-bottom-box_ov7eu_17 ._ranking-list-table_ov7eu_47 {
  margin-top: 0.2rem;
}

._ranking-list-bottom-box_ov7eu_17 ._refresh-btn_ov7eu_50 {
  text-align: center;
}

._ranking-list-bottom-box_ov7eu_17 ._refresh-btn_ov7eu_50 .countdown {
  justify-content: center;
}

._ranking-list-bottom-box_ov7eu_17 ._refresh-btn_ov7eu_50 .countdown span {
  color: #fff;
}

._ranking-list-bottom-box_ov7eu_17 ._refresh-btn_ov7eu_50 .ui-button__text {
  width: 1.2rem;
  line-height: 0.28rem;
}

._ranking-list-bottom-box_ov7eu_17 ._ranking-today_ov7eu_63 {
  margin: 0 0.1rem;
  color: var(--theme-text-color);
}

._ranking-list-bottom-box_ov7eu_17 ._ranking-today_ov7eu_63 .ranking-icon {
  width: 0.5rem;
  min-height: 0.3rem;
  position: relative;
  top: 0.1rem;
}

._ranking-list-bottom-box_ov7eu_17
  ._ranking-today_ov7eu_63
  .ranking-icon:lang(zh) {
  margin-top: -0.02rem;
}

._ranking-list-bottom-box_ov7eu_17 ._today-bonus_ov7eu_76 {
  margin-left: 0.1rem;
  color: var(--theme-text-color);
}

._ranking-list-bottom-box_ov7eu_17 ._yellow_ov7eu_80 {
  color: var(--skin__accent_3);
}

._margin-top-fit_ov7eu_84 {
  margin-top: 0;
}

._ranking-list-yesterday_1nhqp_17 {
  display: flex;
  flex-direction: column;
  color: var(--theme-text-color);
  font-size: 0.22rem;
  background-color: var(--theme-main-bg-color);
  border-radius: 0.1rem;
  box-shadow: 0 0.03rem 0.09rem rgba(0, 0, 0, 0.06);
}

._ranking-list-yesterday_1nhqp_17 .ui-list {
  max-height: 6.26rem;
  overflow-y: auto;
}

._ranking-list-top-box_1nhqp_31 {
  display: flex;
  justify-content: space-between;
}

._ranking-list-top-box_1nhqp_31 ._top_1nhqp_35 {
  display: flex;
  align-items: center;
  height: 0.48rem;
}

._ranking-list-top-box_1nhqp_31 p + p {
  margin-top: 0.12rem;
}

._ranking-list-top-box_1nhqp_31 ._bottom_1nhqp_43 {
  line-height: 1;
}

._ranking-list-top-box_1nhqp_31 ._detail_1nhqp_46 {
  margin-left: 0.1rem;
  color: var(--skin__primary);
  font-size: 0.22rem;
  cursor: pointer;
}

._ranking-list-top-box_1nhqp_31 ._ranking-last_1nhqp_52 {
  margin-left: 0.1rem;
  color: var(--theme-text-color);
  line-height: 1;
}

._ranking-list-top-box_1nhqp_31 ._ranking-last_1nhqp_52 .ranking-icon {
  width: 0.5rem;
  min-height: 0.3rem;
}

._ranking-list-top-box_1nhqp_31 ._ranking-award_1nhqp_61 {
  margin-left: 0.1rem;
}

._ranking-list-top-box_1nhqp_31 ._yellow_1nhqp_64 {
  color: var(--skin__accent_3);
}

._ranking-list-top-box_1nhqp_31 ._ranking-list-top-left_1nhqp_67 p {
  display: flex;
  align-items: center;
}

._detailModal_1nhqp_72 .ui-dialog__header {
  font-size: 0.24rem;
  height: 0.74rem;
  color: var(--theme-text-color);
}

._ranking-list-top-container_orrvr_17 {
  position: sticky;
  top: 0;
  padding: 0.2rem;
  background-color: var(--skin__bg_1);
  z-index: 2;
}

._ranking-list-top-box_orrvr_25 {
  display: flex;
  justify-content: space-between;
  height: 1.32rem;
  padding: 0.2rem;
  color: var(--theme-text-color);
  font-size: 0.22rem;
  background-color: var(--theme-main-bg-color);
  border-radius: 0.1rem;
  box-shadow: 0 0.03rem 0.09rem rgba(0, 0, 0, 0.06);
}

._ranking-list-top-box_orrvr_25 ._top_orrvr_36 {
  display: flex;
  align-items: center;
  height: 0.48rem;
}

._ranking-list-top-box_orrvr_25 p + p {
  margin-top: 0.12rem;
}

._ranking-list-top-box_orrvr_25 ._detail_orrvr_44 {
  margin-left: 0.1rem;
  color: var(--skin__primary);
  font-size: 0.22rem;
  cursor: pointer;
}

._ranking-list-top-box_orrvr_25 ._ranking-last_orrvr_50 {
  margin-left: 0.1rem;
  color: var(--theme-text-color);
}

._ranking-list-top-box_orrvr_25 ._ranking-last_orrvr_50 .ranking-icon {
  width: 0.5rem;
  min-height: 0.3rem;
}

._ranking-list-top-box_orrvr_25 ._ranking-award_orrvr_58 {
  margin-left: 0.1rem;
  color: var(--theme-text-color);
}

._ranking-list-top-box_orrvr_25 ._yellow_orrvr_62 {
  color: var(--skin__accent_3);
}

._ranking-list-top-box_orrvr_25 ._ranking-list-top-left_orrvr_65 p {
  display: flex;
  align-items: center;
}

._detailModal_orrvr_70 .ui-dialog__header {
  font-size: 0.3rem;
  height: 0.74rem;
  color: var(--theme-text-color);
}

._detailModal_orrvr_70 .ui-dialog__content {
  padding: 0 0.2rem 0.2rem;
}

._announcement_wo97m_17 {
  height: 5rem;
}

._announcement_wo97m_17 .loading {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

._announcement_wo97m_17 .record-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0.1rem;
  padding: 0.2rem;
  margin-right: 0.2rem;
}

._announcement_wo97m_17 .record-item:nth-child(odd) {
  background-color: var(--skin__bg_1);
}

._announcement_wo97m_17 .record-item:nth-child(2n) {
  background-color: var(--theme-main-bg-color);
}

._announcement_wo97m_17 .record-item .record-info {
  display: flex;
  align-items: center;
  color: var(--theme-text-color);
  font-size: 0.2rem;
  text-align: left;
}

._announcement_wo97m_17 .record-item .record-info img {
  width: 0.44rem;
  height: 0.44rem;
  margin-right: 0.2rem;
}

._announcement_wo97m_17 .record-item .record-info .record-desc {
  display: flex;
  align-items: center;
  margin-right: 0.1rem;
}

._announcement_wo97m_17 .record-item .record-info .record-desc .time {
  width: 1.6rem;
}

._announcement_wo97m_17 .record-item .amount {
  font-size: 0.22rem;
  color: var(--skin__accent_3);
}

._bet-detail-content_74syr_17 .item {
  margin: 0 0.3rem 0.1rem 0;
  text-align: left;
}

._bet-detail-content_74syr_17 .item label,
._bet-detail-content_74syr_17 .item span {
  font-size: 0.22rem;
  line-height: 0.28rem;
  color: var(--theme-text-color);
}

._bet-detail-content_74syr_17 .item .value {
  margin-left: 0.1rem;
  color: var(--theme-text-color);
  font-weight: 700;
}

._detail-list_1qqdz_17 {
  border-radius: 0.1rem;
}

._detail-list_1qqdz_17 .list-item {
  display: flex;
}

._detail-list_1qqdz_17 .list-item > div {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

._detail-list_1qqdz_17 .list-item > div:first-child,
._detail-list_1qqdz_17 .list-item > div:last-child {
  flex: none;
  width: 30%;
}

._detail-list_1qqdz_17 .head {
  height: 0.8rem;
  background-color: var(--skin__bg_1);
  color: var(--theme-text-color);
  font-size: 0.24rem;
  border-radius: 0.1rem;
  border: var(--lobby__px) solid var(--theme-color-line);
  margin-right: 0.3rem;
}

._detail-list_1qqdz_17 .body {
  height: 0.7rem;
  font-size: 0.2rem;
  color: var(--theme-text-color);
  border-radius: 0.1rem;
  margin-right: 0.3rem;
}

._detail-list_1qqdz_17 .body div {
  line-height: 0.24rem;
}

._detail-list_1qqdz_17 .body:nth-child(2n) {
  background-color: var(--skin__bg_1);
}

._detail-list_1qqdz_17 .body:nth-child(odd) {
  background-color: var(--theme-main-bg-color);
}

._detail-list_1qqdz_17 .body .reward-time {
  display: inline-block;
  width: 1.2rem;
  white-space: pre-wrap;
  line-height: 0.24rem;
}

._detail-list_1qqdz_17 .body .lucky-text {
  color: var(--skin__accent_3);
}

._detail-list_1qqdz_17 .list-main {
  max-height: 3.5rem;
}

._bet-detail-content_1qqdz_71 {
  margin-top: 0.3rem;
}

._bet-detail-content_1qqdz_71 .item {
  margin: 0 0.3rem 0.1rem 0;
  text-align: left;
}

._bet-detail-content_1qqdz_71 .item label,
._bet-detail-content_1qqdz_71 .item span {
  font-size: 0.2rem;
  line-height: 0.28rem;
  color: var(--theme-text-color);
}

._bet-detail-content_1qqdz_71 .item .value {
  margin-left: 0.1rem;
  color: var(--theme-text-color);
  font-weight: 700;
}

._base-info-wrap_wkq00_17 {
  border-bottom: var(--lobby__px) solid var(--theme-color-line);
}

._base-info-wrap_wkq00_17 .bet-tips {
  margin-bottom: 0.2rem;
  font-size: 0.22rem;
  color: var(--theme-text-color);
}

._base-info-wrap_wkq00_17 .bet-tips > span:nth-child(1) {
  margin: 0 0.05rem;
  color: var(--theme-text-color);
}

._base-info-wrap_wkq00_17 .bet-tips > span:nth-child(2) {
  margin: 0 0.05rem;
  color: var(--skin__accent_3);
}

._base-info-wrap_wkq00_17 ._base-info_wkq00_17 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.2rem;
  color: var(--theme-text-color);
  font-size: 0.24rem;
}

._base-info-wrap_wkq00_17 ._base-info_wkq00_17 .info .label {
  margin-right: 0.1rem;
}

._base-info-wrap_wkq00_17 ._base-info_wkq00_17 .info .value {
  color: var(--skin__accent_3);
}

._base-info-wrap_wkq00_17 ._base-info_wkq00_17 .btn {
  padding: 0.2rem 0;
  color: var(--skin__primary);
  font-size: 0.24rem;
  line-height: 1;
  cursor: pointer;
}

html[data-gap-supported='0']
  ._base-info-wrap_wkq00_17
  ._base-info_wkq00_17
  > *
  + * {
  margin-left: 0.2rem;
}

._bet-detail_wkq00_59 {
  width: 6.9rem;
}

._bet-detail_wkq00_59 .ui-dialog__main {
  padding: 0.2rem 0 0.3rem 0.3rem;
  min-height: max-content;
}

._bet-detail_wkq00_59 .ui-dialog__main .ui-dialog__header {
  padding: 0;
  color: var(--theme-text-color);
}

._bet-detail_wkq00_59 .ui-dialog__main .ui-dialog__content {
  margin-top: 0.3rem;
  padding: 0;
}

._my-record_fupzb_17 {
  height: 5rem;
}

._my-record_fupzb_17 .loading {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

._my-record_fupzb_17 .ui-empty {
  height: 100%;
}

._my-record_fupzb_17 .record-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0.1rem;
  padding: 0.2rem;
}

._my-record_fupzb_17 .record-item:nth-child(odd) {
  background-color: var(--skin__bg_1);
}

._my-record_fupzb_17 .record-item:nth-child(2n) {
  background-color: var(--theme-main-bg-color);
}

._my-record_fupzb_17 .record-item .record-info {
  display: flex;
  align-items: center;
  color: var(--theme-text-color);
  font-size: 0.2rem;
  text-align: left;
}

._my-record_fupzb_17 .record-item .record-info img {
  width: 0.44rem;
  height: 0.44rem;
  margin-right: 0.2rem;
}

._my-record_fupzb_17 .record-item .record-info .record-desc {
  display: flex;
  align-items: center;
  margin-right: 0.1rem;
}

._my-record_fupzb_17 .record-item .record-info .record-desc .time {
  width: 1.6rem;
}

._my-record_fupzb_17 .record-item .amount {
  font-size: 0.22rem;
  color: var(--skin__accent_3);
}

._task_163pu_17 ._loading_163pu_17 {
  height: 5rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

._task_163pu_17 ._task-desc_163pu_24 {
  color: var(--theme-text-color);
}

._task_163pu_17 ._lucky-integral_163pu_27 {
  color: var(--skin__accent_3);
}

._task_163pu_17 .task-list {
  padding-right: 0.2rem;
}

._task_163pu_17 .task-list .ui-table__thead {
  background-color: var(--skin__bg_1);
}

._task_163pu_17 .task-list .ui-table__cell {
  min-height: 0.7rem;
  border-radius: 0.1rem;
}

._task_163pu_17 .task-list .ui-table__cell:nth-child(2n) {
  background-color: var(--skin__bg_1);
}

._task_163pu_17 .task-list .ui-table__cell:nth-child(odd) {
  background-color: var(--theme-main-bg-color);
}

._turntable_1i0ek_17 {
  position: relative;
  width: 5rem;
  margin: 0.2rem auto;
}

._turntable_1i0ek_17 .wheel {
  width: 100%;
  height: 5rem;
  background-size: 100% 100%;
  transition: transform 5s ease-in-out;
}

._turntable_1i0ek_17 .whell-btn {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 1.683rem;
  width: 1.65rem;
  height: 1.825rem;
  margin: auto;
  background-position: 0 0;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

._turntable_1i0ek_17 .whell-btn .draw {
  position: relative;
  width: 1.5rem;
  color: var(--theme-jackpot-num-bg-color-1);
  line-height: 1.2;
  text-align: center;
  font-size: 0.28rem;
  transform: translateY(0.07rem);
}

._turntable_1i0ek_17 .whell-btn .draw:lang(hi) {
  margin-top: 0.12rem;
  font-size: 0.28rem;
}

._turntable_1i0ek_17 .whell-btn .draw:lang(it) {
  margin-top: 0.08rem;
}

._turntable_1i0ek_17 .whell-btn .draw:lang(it) p {
  transform: scale(0.85);
}

._turntable_1i0ek_17 .whell-btn .draw:lang(ja) {
  margin-top: 0;
}

._turntable_1i0ek_17 .whell-btn .draw:lang(tr) span {
  -webkit-box-orient: inherit;
  word-break: keep-all;
}

._turntable_1i0ek_17 .whell-btn .draw:lang(ru) > span > span {
  display: block !important;
  transform: scale(0.8);
}

._turntable_1i0ek_17 .wheel-pointer {
  position: absolute;
  top: -0.05rem;
  left: 1.6rem;
  margin: auto;
  width: 1.758rem;
  height: 3.208rem;
  background-position: 0 0;
  background-size: 100% 100%;
}

._turntable_1i0ek_17 .wheel-pointer > img {
  position: relative;
  left: 0.06rem;
  width: 1.667rem;
  height: 3.208rem;
}

._turntable_1i0ek_17._turntable-style8_1i0ek_89 ._whell-item_1i0ek_89,
._turntable_1i0ek_17._turntable-style10_1i0ek_89 ._whell-item_1i0ek_89 {
  width: 1.1rem;
}

._turntable_1i0ek_17._turntable-style12_1i0ek_92 ._whell-item_1i0ek_89 {
  width: 0.9rem;
}

._whell-item_1i0ek_89 {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 1.24rem;
  margin: auto;
  height: 4.458rem;
  color: var(--theme-jackpot-num-bg-color-1);
  font-size: 0.22rem;
  text-align: center;
}

._whell-item_1i0ek_89 ._center_1i0ek_110 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 0.56rem;
}

._whell-item_1i0ek_89 p {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 0.22rem;
  line-height: 0.24rem;
  word-break: break-all;
}

._whell-item_1i0ek_89 img {
  width: 0.665rem;
  height: 0.665rem;
}

._winning_1i0ek_133 {
  animation: _winning_1i0ek_133 0.2s 5 linear;
}

@keyframes _winning_1i0ek_133 {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

._turntable-tabs_1yc53_62 {
  display: flex;
  justify-content: center;
}

._turntable-tabs_1yc53_62 > div {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 2.1rem;
  height: 0.81rem;
  text-align: center;
  border: thin solid var(--theme-color-line);
  border-radius: 0.1rem;
}

._turntable-tabs_1yc53_62 > div:lang(hi) {
  box-shadow: 0 0.05rem 0.18rem rgba(174, 184, 199, 0.2);
}

._turntable-tabs_1yc53_62 > div:not(:nth-child(1)) {
  margin-left: 0.18rem;
}

._turntable-tabs_1yc53_62 > div p {
  width: 100%;
  color: var(--theme-text-color);
  font-size: 0.3rem;
  line-height: 1.2;
}

._turntable-tabs_1yc53_62 > div p:not(:lang(zh)):not(:lang(zh_hk)) {
  font-size: 0.22rem;
}

._turntable-tabs_1yc53_62 > div span {
  color: var(--theme-text-color);
  font-size: 0.24rem;
}

._turntable-tabs_1yc53_62 > div span:not(:lang(zh)):not(:lang(zh_hk)) {
  font-size: 0.18rem;
}

._turntable-tabs_1yc53_62 > div._active_1yc53_99 {
  border: none;
}

._turntable-tabs_1yc53_62 > div._active_1yc53_99 p,
._turntable-tabs_1yc53_62 > div._active_1yc53_99 span {
  color: var(--theme-jackpot-num-bg-color-1);
}

._turntable-tabs_1yc53_62 > div._active_1yc53_99._silver_1yc53_106 {
  background-color: var(--theme-event-luck-wheel-silver);
}

._turntable-tabs_1yc53_62 > div._active_1yc53_99._gold_1yc53_109 {
  background-color: var(--theme-event-luck-wheel-gold);
}
._turntable-tabs_1yc53_62 > div._active_1yc53_99._diamond_1yc53_112 {
  background-color: var(--theme-event-luck-wheel-diamond);
}
</style>
<style scoped>
._introduction-item_1j44v_99 {
  margin-bottom: 0.2rem;
  font-size: 0.28rem;
  line-height: 0.42rem;
  white-space: pre-wrap;
  word-break: break-word;
}
._introduction-title_cvq4f_52 ._title-container_cvq4f_52 {
  position: relative;
  display: inline-block;
  left: -0.28rem;
  height: 0.62rem;
  margin-bottom: 0.2rem;
  max-width: 100%;
}

._introduction-title_cvq4f_52 ._title-container_cvq4f_52 ._title-text_cvq4f_70 {
  position: relative;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-left: 0.28rem;
  padding-right: 0.15rem;
  font-size: 0.32rem;
  height: 0.56rem;
  line-height: 0.56rem;
  background-color: var(--theme-text-color-darken);
  color: var(--theme-btm-bg-color);
  border-top-left-radius: 0.06rem;
  z-index: 1;
}

._introduction-title_cvq4f_52 ._title-container_cvq4f_52:before {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0.08rem;
  height: 0.1rem;
  background-color: var(--theme-text-color-darken);
  border-bottom-left-radius: 0.06rem;
}
._introduction-title_cvq4f_52 ._title-container_cvq4f_52 ._arrow_cvq4f_87 {
  position: absolute;
  top: 0;
  right: -0.26rem;
  width: 0.28rem;
  height: 0.56rem;
  overflow: hidden;
  z-index: 0;
}
._introduction-title_cvq4f_52
  ._title-container_cvq4f_52
  ._arrow_cvq4f_87:before,
._introduction-title_cvq4f_52
  ._title-container_cvq4f_52
  ._arrow_cvq4f_87:after {
  content: '';
  position: absolute;
  top: -0.34rem;
  left: 0;
  border: 0.32rem solid transparent;
  border-left-color: var(--theme-text-color-darken);
}
._introduction-title_cvq4f_52
  ._title-container_cvq4f_52
  ._arrow_cvq4f_87:after {
  content: '';
  position: absolute;
  left: 0;
  border: 0.32rem solid transparent;
  border-left-color: var(--theme-text-color-darken);
  top: 0.26rem;
}
.nUtoDOFYqni_cq_dHUjg {
  align-items: center;
  display: grid;
  font-size: 0.18rem;
  margin-top: 0.2rem;
}

.nUtoDOFYqni_cq_dHUjg .FPKXpabqN25lBr4IA7LQ {
  background-color: rgba(0, 0, 0, 0.08);
  border-bottom: 0.01rem solid hsla(0, 0%, 100%, 0.5);
  border-radius: 0.1rem;
  height: 0.2rem;
}

.nUtoDOFYqni_cq_dHUjg .SC6yMRCGE2upeyEdgibm {
  background-color: var(--theme-secondary-color-success);
  border-radius: 0.1rem;
}

.nUtoDOFYqni_cq_dHUjg .u5sLSrD0KWEulumHoUzc {
  color: #fff;
  line-height: 0.2rem;
}

.nUtoDOFYqni_cq_dHUjg .i9WaVhztJIXx90Q1PPLD {
  display: flex;

  align-items: center;
}

.J5dtKM_LB6fse7jhX2hk {
  overflow: hidden;
  position: relative;
  width: 100%;
}

.J5dtKM_LB6fse7jhX2hk.QF3VjOqeGp_QDYsZS4Ei {
  overflow: visible;
  text-align: center;
}

.J5dtKM_LB6fse7jhX2hk .MtFB4D3SHXXdqKU0qelp {
  height: 100%;
  left: 0;
  position: absolute;
}

.J5dtKM_LB6fse7jhX2hk .kNDhRFHNQ398GxjnCVlg {
  position: absolute;
  text-align: center;
  top: 0;
  left: 0;
  width: 100%;
}

.J5dtKM_LB6fse7jhX2hk .YumY578c3s4HnIJXRiBw i {
  color: var(--theme-primary-font-color);
  font-size: 0.22rem;
}

.Rp9bR9P03_qFsh1PnGSc {
  max-width: 1.5rem;
}

.Rp9bR9P03_qFsh1PnGSc .inner-text {
  text-align: left;
}

.conterms .van-tag--danger {
  display: inline-block;
  box-sizing: border-box;
  min-width: 0.32rem;
  padding: 0 0.08rem;
  color: #fff;
  height: 0.26rem;
  text-align: center;
  position: absolute;
  width: 0.7rem;
  right: 1rem;
  top: -0.25rem;
  border-radius: 0.13rem 0.13rem 0.13rem 0;
  font-size: 0.18rem;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.26rem;
  letter-spacing: normal;
  overflow: visible;
  vertical-align: center;
}
.conterms .van-tag--danger:before {
  content: '';
  display: inline-block;
  position: absolute;
  bottom: -0.06rem;
  z-index: 20;
  left: 0;
  width: 0;
  height: 0;
  border-left: 0.079rem solid #ee0a24;
  border-top: 0.066rem solid transparent;
  border-bottom: 0.066rem solid transparent;
  font-size: 0;
}
.R57xbU1vEwuho81iaSVT-conter {
  font-size: 0.2rem;
}
.R57xbU1vEwuho81iaSVT-conter .ant-col {
  -ms-flex-align: center;
  align-items: center;
  color: var(--theme-text-color-darken);
  display: -ms-flexbox;
  display: flex;
}

.R57xbU1vEwuho81iaSVT-conter .van-row {
  justify-content: center;
  display: flex;
  align-items: center;
}

.R57xbU1vEwuho81iaSVT-conter .van-col {
  margin-bottom: 0.2rem;
}

.R57xbU1vEwuho81iaSVT-conter .van-col label {
  color: var(--theme-text-color-lighten);
  margin-right: 0.1rem;
}

.R57xbU1vEwuho81iaSVT-conter .currencyAmount {
  color: var(--theme-text-color-darken);
  max-width: 50%;
}
.R57xbU1vEwuho81iaSVT-conter .yellow {
  color: var(--theme-secondary-color-finance);
}
.R57xbU1vEwuho81iaSVT-conter .red {
  color: var(--theme-secondary-color-error);
}
.footerOCmens {
  border-radius: 0.1rem;
  border: 0.01rem solid var(--theme-color-line);
  background-color: var(--theme-main-bg-color);
  color: var(--theme-text-color-darken);
}
.conterms {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.24rem;
  border-radius: 0.1rem;
  padding: 0.2rem 0.2rem 0.2rem 0.1rem;
}
.conterms:nth-child(even) {
  background-color: var(--theme-bg-color);
}
.conterms div {
  box-sizing: border-box;
  text-align: center;
}
.conterms .yJrr5gS3ZL4NGzZkaPXH {
  font-size: 0.16rem;
  height: 0.6rem;
  width: 1.6rem;
  padding: 0 0.15rem;
}
.orkXHvtNM5R_5twq6l5I {
  background-color: var(--theme-main-bg-color);
  bottom: 0;
  -webkit-box-shadow: 0 -0.03rem 0.1rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 -0.03rem 0.1rem 0 rgba(0, 0, 0, 0.1);
  display: -ms-flexbox;
  display: flex;
  -ms-flex: none;
  flex: none;
  height: 1.3rem;
  position: fixed;
  z-index: 2;
}
.orkXHvtNM5R_5twq6l5I > button {
  margin: 0.2rem auto auto;
  border-radius: 0.1rem;
}
.orkXHvtNM5R_5twq6l5I > button:first-child {
  margin-left: 0.2rem;
  margin-right: 0.1rem;
}
.orkXHvtNM5R_5twq6l5I > button:last-child {
  margin-left: 0.1rem;
  margin-right: 0.2rem;
}
.orkXHvtNM5R_5twq6l5I .RRWQlUJLCPB59ggBUdFl {
  background-color: var(--theme-main-bg-color);
  border: thin solid var(--theme-primary-color);
  color: var(--theme-primary-color) !important;
  color: var(--theme-primary-font-color);
  height: 0.8rem;
  font-size: 0.26rem;
  line-height: 1.2;
  margin-right: 0;
  text-align: center;
  width: 3.45rem;
}
.orkXHvtNM5R_5twq6l5I .yJrr5gS3ZL4NGzZkaPXH {
  color: var(--theme-primary-font-color);
  line-height: 1.2;
  text-align: center;
  width: 3.45rem;
  height: 0.8rem;
  font-size: 0.26rem;
}
.ant-btn.ant-btn-primary1 {
  background-color: var(--theme-disabled-bg-color);
  border-color: var(--theme-disabled-bg-color);
  color: var(--theme-disabled-font-color);
}
.ant-btn.ant-btn-primary {
  background-color: var(--theme-primary-color);
  border-color: var(--theme-primary-color);
}
</style>
